import yup from 'src/utilities/Yup/yup';

const schema = {
  otp: yup.string().label('otp_form_otp_label').required(),
};

export const otpFormSchema = yup.object(schema).required();

export type PinOtpFormData = yup.InferType<typeof otpFormSchema>;
